import { DemandService } from "../DemandService/demand.service"
import { DemandDelegate } from "../DemandService/demand.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class DemandServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService): DemandService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new DemandDelegate(config, httpProvider);
        return new DemandService(delegate);
    }
}